import moment from 'moment';
import { DatePicker } from '../../../../components/ClickableField/ClickableField';
import React from 'react';
import { injectIntl } from 'react-intl';

const MarketValueUpdateDateInput = props => {
  const { intl, InputAdornmentProps, ...rest } = props;

  return (
    <DatePicker
      name="marketValueUpdateDate"
      format="DD-MMM-YYYY"
      openTo="day"
      maxDate={moment()}
      label={`${intl.formatMessage({ id: 'market-value-update-date' })}:`}
      slotProps={{
        field: { clearable: true }
      }}
      {...rest}
    />
  );
};

export default injectIntl(MarketValueUpdateDateInput);
